import { DisabledDividerStyled } from '@/components/DisabledDivider/styled';
import { Icon } from '@shopify/polaris';
import { DisabledIcon } from '@shopify/polaris-icons';

const DisabledDivider = () => {
  return (
    <DisabledDividerStyled>
      <div className="icon-wrapper">
        <Icon tone="critical" source={DisabledIcon} />
      </div>
      <div className="line"></div>
    </DisabledDividerStyled>
  );
};

export default DisabledDivider;
